var organizations = [
  {
    id: 0,
    name: "Student Council",
    yearsActive: "Aug. 2017 - May 2020",
    role: [
      {
        title: "Junior Class Vice President",
        years: "Aug. 2018 - May 2019",
      },
    ],
    summary: "Elected to represent students to school administration",
    description: ["Effectively communicated with a large group of students"],
    logo: "https://willfeldman.com/src/student_council_logo.jpeg",
    headerImage:
      "https://willfeldman.com/src/student_council_background.jpeg",
  },
  {
    id: 1,
    name: "Bexleo Student Yearbook",
    yearsActive: "Aug. 2017 - July 2020",
    role: [
      {
        title: "Co-Executive Editor",
        years: "Aug. 2019 - July 2020",
      },
      {
        title: "Website Editor",
        years: "Aug. 2017 - May 2019",
      },
    ],
    summary: "Bexley High School’s top-rated yearbook program",
    description: [
      "Spearheaded all decisions and organization for the yearbook program",
      "Led daily meetings, delegated tasks, and planned assignments for the group",
    ],
    logo: "https://willfeldman.com/src/bexleo_logo.png",
    headerImage: "https://willfeldman.com/src/bexleo_background.png",
  },
  {
    id: 2,
    name: "Key Club",
    yearsActive: "Aug. 2016 - May 2020",
    role: [
      {
        title: "President",
        years: "Aug. 2018 - May 2020",
      },
      {
        title: "Vice President",
        years: "Aug. 2017 - May 2018",
      },
    ],
    summary:
      "International, student-led organization that provides its members with opportunities to provide service",
    description: [
      "Led a group of Bexley High School students in bi-weekly meetings",
      "In charge of executive decisions and leading the local executive board",
    ],
    logo: "https://willfeldman.com/src/key_club_logo.png",
    headerImage: "https://willfeldman.com/src/key_club_background.png",
  },
  {
    id: 3,
    name: "CISV Columbus",
    yearsActive: "Jan. 2016 - June 2020",
    role: [
      {
        title: "Social Media Marketing",
        years: "Aug. 2018 - May 2020",
      },
      {
        title: "Vice President",
        years: "Aug. 2017 - May 2018",
      },
    ],
    summary: "Educates and inspires action for a more just and peaceful world",
    description: [
      "Maintained social media to inform and promote local events, using Adobe Photoshop and Illustrator to make announcements for Instagram, Twitter, and Facebook",
    ],
    logo: "https://willfeldman.com/src/cisv_logo.png",
    headerImage: "https://willfeldman.com/src/cisv_background.png",
  },
  {
    id: 4,
    name: "Entrepreneurs Club",
    yearsActive: "Sept. 2020 - Present",
    role: [
      {
        title: "Director of Technology",
        years: "May 2023 - Present",
      },
      {
        title: "Associate Director of Technology",
        years: "Dec. 2022 - May 2023",
      },
      {
        title: "Photographer",
        years: "May 2022 - Dec. 2022",
      },
    ],
    summary:
      "Educating, inspiring, and empowering the world's future entrepreneurs, innovators, and leaders",
    description: [
      "Photographed events and attended board meetings to plan events for Entrepreneurs Club - the largest club at Northeastern University",
    ],
    logo: "https://willfeldman.com/src/eclub_logo.png",
    headerImage: "https://willfeldman.com/src/eclub_background.png",
  },
];

module.exports = { organizations };